import { render } from "./LbrxSideMenu.vue?vue&type=template&id=be43ccd4&scoped=true"
import script from "./LbrxSideMenu.vue?vue&type=script&lang=js"
export * from "./LbrxSideMenu.vue?vue&type=script&lang=js"

import "./LbrxSideMenu.vue?vue&type=style&index=0&id=be43ccd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be43ccd4"]])

export default __exports__